// Dubletten und Zusammenführen (Agent 7C, Runde 7): Gruppen mit gleichem Namen, gleicher Nummer, E-Mail-Adresse oder Domain, Vorschau
// und Zusammenführen, Protokoll, "keine Dublette" merken (L21, AU-04). Die Route ist `/dubletten` (Eintrag in der Seitenleiste nur mit
// dem Recht `leads_zusammenfuehren`); die Bausteine liegen in `src/dubletten/`, der Client in `src/api/dubletten.ts`, die Routen stehen in
// API.md 22.3. Zusammenführen und Löschen aus dem Lead-Menü: `components/lead/dublettenMenue.tsx` (ebenfalls 7C).
import { DublettenStart } from "../dubletten/DublettenStart";

export default function Dubletten() {
  return <DublettenStart />;
}
